import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=5570b2aa"
import script from "./UserSearch.vue?vue&type=script&lang=ts"
export * from "./UserSearch.vue?vue&type=script&lang=ts"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=5570b2aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports